import React, { useEffect, useContext, useState } from 'react';
import clsx from 'clsx';

import { PluginContext } from '../../../contexts';

import {
   Card,
   CardContent,
   Container,
   Grid,
   Typography,
   Button,
   IconButton,
   Divider,
   colors
} from '@material-ui/core';

import {
   Alert,
   AlertTitle
} from '@material-ui/lab';

import {
   FieldError,
   UploadFile
} from '../../../common';

import {
   Form,
   Formik,
   Field
} from 'formik';

import {
   TextField,
   CheckboxWithLabel
} from 'formik-material-ui';

import {
   AppleCertificatesWizard
} from './Wizards';

import { PageContext } from '../PageContext';
import { ToastContext } from '../../../contexts/ToastContext';

import { FileType, MaxFileSize, getColoredBottonStyle } from '../../../../helpers';

import { useTranslation } from "react-i18next";

import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import DeleteIcon from '@material-ui/icons/Delete';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
   root: {
   },
   title: {
      fontSize: "1.2em"
   },
   content: {
      marginTop: theme.spacing(4)
   },
   field: {
      width: "100%"
   },
   progress: {
      color: "black"
   },
   pickerBox: {
      marginLeft: "-6px"
   },
   deleteButton: {
      //...getColoredBottonStyle(theme, colors.red)
      color: colors.red[500],
      marginLeft: theme.spacing(2)
   },
   resetButton: {
      ...getColoredBottonStyle(theme, colors.red)
   },
   helpMeButton: {
      ...getColoredBottonStyle(theme, colors.orange)
   },
   wizard: {
      marginTop: theme.spacing(2)
   }
}));

// wpApAdminSettings is a global variable defined in WP
// To allow webpack to build and not giving error we are
// creating a local reference only if it exists 
// (basically when the javascript is executed inside the WordPress context)
let _wpApAdminSettings = {};
if (typeof variable !== 'wpApAdminSettings') {
   _wpApAdminSettings = window['wpApAdminSettings'];
}

export const IosForm = ({
   formRef,
   errors,
   validationSchema,
   disabled,
   upload,
   createCerts,
   onBlur,
   onSubmit,
   ...props }) => {
   const classes = useStyles();

   const { t, i18n } = useTranslation();

   const {
      state,
      mergeSettings
   } = useContext(PageContext);

   const {
      showSuccessMessage,
      showWarningMessage
   } = useContext(ToastContext);

   const {
      settings
   } = state;

   const uploadFileAsync = async (fileType, data, file, credentials) => {
      if (upload) {
         const storedFileInfo = await upload(fileType, data, file, credentials);
         if (storedFileInfo !== null) {
            switch (fileType) {
               case FileType.iOSP12Certificate:
                  mergeSettings({ iOSP12CertificateFile: storedFileInfo.publicUrl });
                  showSuccessMessage(t("MessageFileUploadOk"));
                  break;
               case FileType.iOSMobileProvisioning:
                  mergeSettings({ iOSMobileProvisionFile: storedFileInfo.publicUrl });
                  showSuccessMessage(t("MessageFileUploadOk"));
                  break;
               default:
                  break;
            }
            return true;
         } else {
            return false;
         }
      } else {
         return false;
      }
   }

   const getInitialValues = () => {
      return {
         enableiOSBuild: settings.enableiOSBuild ? settings.enableiOSBuild : false,
         iOSCertificatePassword: settings.iOSCertificatePassword ? settings.iOSCertificatePassword : "",
         iOSP12CertificateFile: settings.iOSP12CertificateFile ? settings.iOSP12CertificateFile : "",
         iOSMobileProvisionFile: settings.iOSMobileProvisionFile ? settings.iOSMobileProvisionFile : "",
      };
   }

   const fileDropHandler = (fileType, file) => {
      let isFileOk = false;
      let wrongFileMessage = null
      if (file.size <= MaxFileSize.Max5MB) {
         switch (fileType) {
            case FileType.iOSP12Certificate:
               isFileOk = file.type === "application/x-pkcs12" && file.name.includes(".p12");
               wrongFileMessage = t("MessageiOSInvalidP12File");
               break;
            case FileType.iOSMobileProvisioning:
               isFileOk = file.name.includes(".mobileprovision");
               wrongFileMessage = t("MessageiOSInvalidPPFile");
               break;
            default:
               return false;
         }
      } else {
         showWarningMessage(t("MessageWrongFileSize5"));
         return false;
      }

      if (isFileOk) {
         return true;
      } else {
         showWarningMessage(wrongFileMessage);
         return false;
      }
   }

   const submitClickHandler = (values, actions) => {
      if (onSubmit) onSubmit(values, () => actions.setSubmitting(false));
   }

   const resetValuesHandler = () => {
      mergeSettings({
         iOSCertificatePassword: "",
         iOSP12CertificateFile: "",
         iOSMobileProvisionFile: ""
      });
   }

   const [inWizard, setInWizard] = useState(false);
   const startWizardClickHandler = () => {
      setInWizard(true);
   }

   const wizardCompletedHandler = async (keyId, teamId, email, bundleId) => {
      if (createCerts) {
         const certsInfo = await createCerts(keyId, teamId, email, bundleId);
         if (certsInfo) {
            setInWizard(false);
            mergeSettings({
               iOSCertificatePassword: certsInfo.p12Password,
               iOSP12CertificateFile: certsInfo.p12PublicUrl,
               iOSMobileProvisionFile: certsInfo.profilePublicUrl
            });
         }
      }
   }

   const [isConfigured, setIsConfigured] = useState(false);
   useEffect(() => {
      setIsConfigured(
         settings.iOSCertificatePassword
         && settings.iOSP12CertificateFile
         && settings.iOSMobileProvisionFile
      );
   }, [settings]);

   const {
      getAssetUrl
   } = useContext(PluginContext);

   return (
      <Card className={clsx(classes.root, props.className)}>
         <CardContent>
            <Container maxWidth="lg" className={classes.content}>
               <Formik
                  enableReinitialize
                  initialValues={getInitialValues()}
                  onSubmit={submitClickHandler}
                  innerRef={formRef}
                  validationSchema={validationSchema}
                  validateOnChange={false}
                  validateOnBlur={true}
                  validate={(values) => {
                     if (onBlur) onBlur(values);
                  }}>
                  {(props) => {
                     const {
                        values,
                        isSubmitting,
                        handleSubmit,
                        setFieldValue
                     } = props;
                     return (
                        <Form noValidate autoComplete="off">
                           <Grid container spacing={3}>
                              <Grid container item xs={12} alignContent="center" justify="space-between">
                                 <div>
                                    <Field
                                       type="checkbox"
                                       name="enableiOSBuild"
                                       component={CheckboxWithLabel}
                                       Label={{ label: t("LabeliOSBuildEnabled") }}
                                       disabled={disabled}
                                    />
                                    <FieldError
                                       name="enableiOSBuild"
                                       errors={errors}
                                    />
                                 </div>

                                 <Button
                                    className={classes.helpMeButton}
                                    onClick={() => window.open(getAssetUrl(t("LabeliOSBuildHelpUrl")))}>
                                    {t("LabelHints")}
                                 </Button>

                                 <Button
                                    className={classes.resetButton}
                                    disabled={!values.enableiOSBuild || !isConfigured || disabled}
                                    onClick={() => resetValuesHandler()}>
                                    {t("ButtonResetCertificates")}
                                 </Button>
                              </Grid>
                              {false && values.enableiOSBuild &&
                                 <>
                                    <Grid item xs={12}>
                                       {inWizard ?
                                          <>
                                             {settings.bundleId ?
                                                <>
                                                   <Alert severity="info" variant="outlined">
                                                      <span
                                                         dangerouslySetInnerHTML={{ __html: t("LabeliOSCertWizardWizardHint") }}
                                                      />
                                                   </Alert>
                                                   <AppleCertificatesWizard
                                                      className={classes.wizard}
                                                      upload={upload}
                                                      disabled={!values.enableiOSBuild || disabled}
                                                      onWizardCanceled={() => setInWizard(false)}
                                                      onWizardComplete={wizardCompletedHandler}
                                                   />
                                                </>
                                                :
                                                <>
                                                   <Alert severity="warning" variant="outlined">
                                                      <span
                                                         dangerouslySetInnerHTML={{ __html: t("LabelCertWizardBundleId") }}
                                                      />
                                                   </Alert>
                                                </>
                                             }
                                          </>
                                          :
                                          <>
                                             {!isConfigured &&
                                                <Alert
                                                   severity="info"
                                                   variant="outlined">
                                                   <AlertTitle>
                                                      {t("LabelCertWizardHelpTitle")}
                                                   </AlertTitle>
                                                   <div
                                                      dangerouslySetInnerHTML={{ __html: t("LabeliOSCertWizardHelpBody") }}
                                                   />
                                                   <Grid container justify="flex-end">
                                                      <Grid item>
                                                         <Button
                                                            color="primary"
                                                            variant="contained"
                                                            disabled={!values.enableiOSBuild || disabled}
                                                            onClick={startWizardClickHandler}>
                                                            {t("ButtonStartWizard")}
                                                         </Button>
                                                      </Grid>
                                                   </Grid>
                                                </Alert>
                                             }
                                          </>
                                       }
                                    </Grid>
                                 </>
                              }
                              {!inWizard &&
                                 <>
                                    <Grid item xs={12}>
                                       <Field
                                          className={classes.field}
                                          name="iOSCertificatePassword"
                                          type="password"
                                          variant="outlined"
                                          label={t("LabeliOSCertificatePassword")}
                                          helperText={t("HelperiOSCertificatePassword")}
                                          disabled={!values.enableiOSBuild || values.iOSP12CertificateFile !== "" || inWizard || disabled}
                                          component={TextField}
                                          inputProps={{
                                             autoComplete: 'new-password',
                                             form: {
                                                autoComplete: 'off'
                                             }
                                          }}
                                       />
                                       <FieldError
                                          name="iOSCertificatePassword"
                                          errors={errors}
                                       />
                                    </Grid>
                                    <>
                                       {values.iOSP12CertificateFile ?
                                          <Grid container item xs={12} alignItems="center" justify="flex-start">
                                             <InsertDriveFileIcon fontSize="large" />
                                             <Typography>
                                                {`${FileType.iOSP12Certificate}.p12`}
                                             </Typography>
                                             <IconButton
                                                className={classes.deleteButton}
                                                size="small"
                                                disabled={!values.enableiOSBuild || inWizard || disabled}
                                                onClick={() => mergeSettings({ iOSP12CertificateFile: "" })}>
                                                <DeleteIcon />
                                             </IconButton>
                                          </Grid>
                                          :
                                          <Grid item xs={12}>
                                             <UploadFile
                                                title={t("LabeliOSP12CertificateFile")}
                                                singleFile
                                                onFileDrop={(files) => fileDropHandler(FileType.iOSP12Certificate, files[0])}
                                                disabled={!values.enableiOSBuild || inWizard || disabled}
                                                upload={(data, file) => uploadFileAsync(
                                                   FileType.iOSP12Certificate,
                                                   data,
                                                   file,
                                                   { password: values.iOSCertificatePassword }
                                                )}
                                                helpText={t("LabelUploadHelp")}
                                                uploadButtonText={t("LabelUploadFile")}
                                                removeButtonText={t("LabelRemoveFile")}
                                                removeAllButtonText={"LabelRemoveAllFiles"}
                                             />
                                             <FieldError
                                                name="iOSP12CertificateFile"
                                                errors={errors}
                                             />
                                          </Grid>
                                       }

                                    </>
                                    <>
                                       {values.iOSMobileProvisionFile ?
                                          <Grid container item xs={12} alignItems="center" justify="flex-start">
                                             <InsertDriveFileIcon fontSize="large" />
                                             <Typography>
                                                {`${FileType.iOSMobileProvisioning}.mobileprovision`}
                                             </Typography>
                                             <IconButton
                                                className={classes.deleteButton}
                                                size="small"
                                                disabled={!values.enableiOSBuild || inWizard || disabled}
                                                onClick={() => mergeSettings({ iOSMobileProvisionFile: "" })}>
                                                <DeleteIcon />
                                             </IconButton>
                                          </Grid>
                                          :
                                          <Grid item xs={12}>
                                             <UploadFile
                                                title={t("LabeliOSMobileProvisionFile")}
                                                singleFile
                                                onFileDrop={(files) => fileDropHandler(FileType.iOSMobileProvisioning, files[0])}
                                                disabled={!values.enableiOSBuild || inWizard || disabled}
                                                upload={(data, file) => uploadFileAsync(FileType.iOSMobileProvisioning, data, file)}
                                                helpText={t("LabelUploadHelp")}
                                                uploadButtonText={t("LabelUploadFile")}
                                                removeButtonText={t("LabelRemoveFile")}
                                                removeAllButtonText={"LabelRemoveAllFiles"}
                                             />
                                             <FieldError
                                                name="iOSMobileProvisionFile"
                                                errors={errors}
                                             />
                                          </Grid>
                                       }

                                    </>
                                 </>
                              }
                           </Grid>
                        </Form>
                     );
                  }}
               </Formik>
            </Container>
         </CardContent>
      </Card>
   );
}